/*
 *
 * Courses constants
 *
 */

export const FLUSH_STATE = 'app/Courses/FLUSH_STATE';

export const LOAD_COURSES = 'app/Courses/LOAD_COURSES';
export const LOAD_COURSES_SUCCESS = 'app/Courses/LOAD_COURSES_SUCCESS';
export const LOAD_COURSES_ERROR = 'app/Courses/LOAD_COURSES_ERROR';

export const UPDATE_COURSE = 'app/Courses/UPDATE_COURSE';
export const UPDATE_COURSE_SUCCESS = 'app/Courses/UPDATE_COURSE_SUCCESS';
export const UPDATE_COURSE_ERROR = 'app/Courses/UPDATE_COURSE_ERROR';

export const HARD_DELETE_COURSE = 'app/Courses/HARD_DELETE_COURSE';
export const HARD_DELETE_COURSE_SUCCESS = 'app/Courses/HARD_DELETE_COURSE_SUCCESS';
export const HARD_DELETE_COURSE_ERROR = 'app/Courses/HARD_DELETE_COURSE_ERROR';